import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconTick = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({ viewBox: "-2 -5 24 24" }, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "M6 13.439L0 7.43902L1.42 6.01902L6.69 11.299L17.98 -0.000976562L19.4 1.41902L7.4 13.419C7.2157 13.6049 6.96584 13.7112 6.70408 13.7149C6.44232 13.7187 6.18953 13.6196 6 13.439Z" }))));
};
